import { default as domainGroupCategory } from './category/store'
import { default as domainGroupStatus } from './status/store'
import { default as domainGroupBase } from './base/store'
import { default as domainGroupIdentifier } from './identifier/store'
import { default as domainGroup } from './group/store'

export default {
    domainGroupCategory,
    domainGroupStatus,
    domainGroupBase,
    domainGroupIdentifier,
    domainGroup
}